import { GET_USERS_LIST, SET_FITER_USER } from '@jumbo/constants/ActionTypes';

const INIT_STATE = {
  usersList: [],
  userFilter: {
    by_name: '',
  },
  metaUsers: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_LIST:
      return {
        ...state,
        usersList: action.payload.users,
        metaUsers: action.payload.meta,
      };

    case SET_FITER_USER:
      return {
        ...state,
        userFilter: action.payload,
      };

    default:
      return state;
  }
};
